<template>
  <div class="hekate-progress-bar d-none">
    <div class="content-wrapper">
      <div
        class="progress"
        role="progressbar"
        aria-label="Success example"
        aria-valuenow="10"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          class="progress-bar bg-success"
          style="width: 10%"
        ></div>
      </div>
    </div>
  </div>
</template>
